import Vue from "vue";
import VueI18n from "vue-i18n";
import jpMessage from "./ja.json";

Vue.use(VueI18n);

const messages = {
  ja: jpMessage
};

const i18n = new VueI18n({
  locale: "ja",
  messages,
  fallbackLocale: "en"
});

export default i18n;
